import type { ErrorLike } from '@apollo/client';

import { SPAN_SELECT_ENERGY_TARIFF } from '@constants/otel';
import { EnergyQuoteType } from '@generated/gql/graphql';
import { useSelectEnergy } from '@hooks/useEnergySelection';
import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useTrace } from '@services/otel';

const useTariffSelection = () => {
  const { withTrace } = useTrace();
  const { basketId } = useBasketContext();

  const { selectQuotes, loading, error, reset } = useSelectEnergy();
  const setSnackbarError = useSnackbarError(reset);

  const executeSelect = async (quoteType: EnergyQuoteType) => {
    try {
      const result = await selectQuotes(basketId, quoteType);
      return result;
    } catch (error) {
      setSnackbarError(error as ErrorLike);
      return;
    }
  };

  const handleSelect = (quoteType: EnergyQuoteType) =>
    withTrace(SPAN_SELECT_ENERGY_TARIFF, () => executeSelect(quoteType));

  return {
    handleSelect,
    loading,
    error,
  };
};

export { useTariffSelection };
